import { fromJS } from "immutable";
import { SchemaFormReducer } from "./reducers/schema.form";
export const schemaFormReducer = new SchemaFormReducer(fromJS({}));
//# sourceMappingURL=reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/fx-schema-form-react/libs/reducer.js
// module id = 328
// module chunks = 3